import {API_HOST_NAME} from "../../constants.js";
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js";

const useServicesResources = (teamId, projectId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/projects/${projectId}/services`;
  return useAuthenticatedResources(url, {}, [
    { name: "start", method: "POST", member: true },
    { name: "stop", method: "POST", member: true },
    { name: "restart", method: "POST", member: true },
  ])
}

export default useServicesResources;
